(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('AppAttestLogDetailController', AppAttestLogDetailController);

    AppAttestLogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'AppAttestLog'];

    function AppAttestLogDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, AppAttestLog) {
        var vm = this;

        vm.appAttestLog = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:appAttestLogUpdate', function(event, result) {
            vm.appAttestLog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
